exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.pagination{\n    padding-top: 20px;\n}\n", ""]);

